import checkWebGL from './3d/checkWebGL'
import addSearch from './api/addSearch'
import formatSearch from './api/formatSearch'
import getLinkHref from './api/getLinkHref'
import getParams from './api/getParams'
import processErrors from './bulk/processErrors'
import createChildren from './fileExplorer/createChildren'
import findInTree from './fileExplorer/findInTree'
import parseOid from './snmp/parseOid'

// Export named modules
export {
  checkWebGL,
  addSearch,
  formatSearch,
  getLinkHref,
  getParams,
  processErrors,
  createChildren,
  findInTree,
  parseOid
}

// Export global utils module as Vue plugin
export default {
  install: (Vue) => {
    Vue.prototype.$utils = {
      ...Vue.prototype.$utils,
      checkWebGL,
      addSearch,
      formatSearch,
      getLinkHref,
      getParams,
      processErrors,
      createChildren,
      findInTree,
      parseOid
    }
  }
}
